import React from "react";

const CustomTable = ({ columns = [], data = [] }) => {
  return (
    <div className="overflow-x-auto bg-white shadow-lg rounded-[10px] px-5 py-4">
      <table className="min-w-full border-collapse text-sm font-medium text-gray-900">
        <thead className="text-[15px] text-center text-gray-700 bg-gray-100">
          <tr className="border-b border-gray-300">
            {columns.map((col, index) => (
              <th
                key={col.key}
                scope="col"
                className={`px-6 py-4 text-center 
                  ${index === 0 ? "rounded-s-lg" : ""} 
                  ${index === columns.length - 1 ? "rounded-e-lg" : ""}`}
              >
                {col.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="bg-white">
          {data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="px-6 py-4 text-center text-gray-500 rounded-b-lg"
              >
                No data available
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="hover:bg-gray-50 transition-colors duration-150 border-b border-gray-200"
              >
                {columns.map((col, colIndex) => (
                  <td
                    key={col.key}
                    className={`px-6 py-4 text-center text-gray-700 
                      ${rowIndex === data.length - 1 && colIndex === 0 ? "rounded-bl-lg" : ""}
                      ${rowIndex === data.length - 1 && colIndex === columns.length - 1 ? "rounded-br-lg" : ""}`}
                  >
                    {col.render
                      ? col.render(row[col.key], row)
                      : row[col.key] ?? "-"}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CustomTable;
